'use strict';
export const GTM_ID = '';
export const AUTHORIZATION = 'Bearer';
